import { useEffect } from 'react';
import globalEvents from '@/utils/globalEvents';
import useConfirmation from './useConfirmation';
// Hook to prompt user to abandon changes
// requiring ConfirmationPrompt component
// to be mounted in the app
export default function useAbandonChanges(_ref) {
  let {
    id,
    title,
    hasUpdates,
    onCancel,
    onConfirm
  } = _ref;
  const {
    openConfirmationPrompt
  } = useConfirmation({
    id,
    title,
    onConfirm,
    onCancel
  }); // Confirm user wants to abandon changes

  useEffect(() => {
    return globalEvents.subscribe('modalClose', () => {
      // Immediately close if no updates
      if (!hasUpdates) {
        typeof onCancel === 'function' && onCancel();
        return;
      }

      openConfirmationPrompt();
    });
  }, [onCancel, hasUpdates, openConfirmationPrompt]);
}